/* eslint-disable react-hooks/rules-of-hooks */
import { Grid } from '@mui/material'
import { Button, Form } from 'components'
import { PageContent } from 'layout'
import { useLayoutContext } from 'layout/layout.context'
import { useAuth } from 'lib/auth'
// import { useCreateCustomer } from 'modules/customers/hooks/useCreateCustomer'

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { Yup } from 'utils'
import {
  AddressType,
  ContactType,
  GeneralSchema,
  GeneralType,
  AddressSchema,
  generalDefaultValues,
  contactDefaultValues,
  addressDefaultValues,
  GeneralForm,
  ContactForm,
  AddressForm
} from './components'
import { useCreateCustomer } from 'modules/customers/hooks'

type FormValues = {
  general: GeneralType
  contact: ContactType
  address: AddressType
}

const schema = Yup.object({
  general: GeneralSchema,
  contact: Yup.object({
    contact: Yup.string()
      .max(40)
      .test(
        'required-if-legal',
        'Campo obrigatório',
        function (value, context) {
          const rootValue = (context as any)?.from?.[1]?.value
          const personType = rootValue?.general?.personType
          const isLegalPerson = personType?.id === '0' // Jurídica
          if (isLegalPerson && !value) {
            return false
          }
          return true
        }
      ),
    phone: Yup.string()
      .max(20)
      .test(
        'required-if-legal',
        'Campo obrigatório',
        function (value, context) {
          const rootValue = (context as any)?.from?.[1]?.value
          const personType = rootValue?.general?.personType
          const isLegalPerson = personType?.id === '0' // Jurídica
          if (isLegalPerson && !value) {
            return false
          }
          return true
        }
      ),
    email: Yup.string()
      .max(60)
      .test('email-validation', 'E-mail inválido', function (value) {
        // Se não há valor, não valida formato (campo opcional para pessoa física)
        if (!value || value.trim() === '') {
          return true
        }
        // Valida formato de email apenas se houver valor
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(value)
      })
      .test(
        'required-if-legal',
        'Campo obrigatório',
        function (value, context) {
          const rootValue = (context as any)?.from?.[1]?.value
          const personType = rootValue?.general?.personType
          const isLegalPerson = personType?.id === '0' // Jurídica
          if (isLegalPerson && !value) {
            return false
          }
          return true
        }
      )
  }),
  address: AddressSchema
})

const defaultValues = {
  general: generalDefaultValues,
  contact: contactDefaultValues,
  address: addressDefaultValues
}

const SubmitButtons = () => {
  const { watch } = useFormContext<FormValues & { _customerExists?: boolean }>()
  const customerExists = watch('_customerExists')

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem'
      }}
    >
      <Button
        variant="text"
        style={{ width: 150 }}
        onClick={() => console.log('cancel button')}
      >
        Cancelar
      </Button>
      <Button
        sx={{ width: 150 }}
        form="create-customer-form"
        type="submit"
        disabled={!!customerExists}
      >
        Cadastrar
      </Button>
    </div>
  )
}

export const CreateCustomerPage = () => {
  const navigation = useNavigate()
  const { mutateAsync } = useCreateCustomer()
  const { user } = useAuth()
  const { setBreadcrumbs } = useLayoutContext()

  useEffect(() => {
    setBreadcrumbs([
      { label: 'Início', to: '/home' },
      { label: 'Clientes', to: '/customers' },
      { label: 'Novo Cliente' }
    ])
    return () => setBreadcrumbs([])
  }, [])

  async function handleCreateCustomer(dataCreate: any) {
    const {
      birthDate,
      observation,
      registration,
      cnpjCpf,
      nickname,
      fullName,
      unity,
      registrationExempt,
      phone
    } = dataCreate.general

    const { phone: contactPhone, contact, email } = dataCreate.contact

    const { state, zipCode, street, number, complement, district, city } =
      dataCreate.address

    const hasBirthDate = birthDate ? new Date(birthDate).toISOString() : null

    const dataCustomer = {
      cnpjCpf: cnpjCpf.replace(/\D/g, ''),
      fullName,
      nickname,
      birthDate: hasBirthDate,
      observation,
      unityId: unity.id,
      registration: registration,
      registrationExempt,
      contactPhone: contactPhone ? contactPhone.replace(/\D/g, '') : '',
      phone: phone.replace(/\D/g, ''),
      state: state.id,
      zipCode: Number(zipCode.replace(/\D/g, '')),
      contact: contact || '',
      email: email || '',
      street,
      number,
      complement,
      district,
      city: city.name,
      sellerId: user?.companyId
    }
    // console.log(dataCustomer)
    await mutateAsync(dataCustomer)
    // navigation(`/customers`)
  }

  return (
    <div>
      <PageContent>
        <Form<FormValues>
          id="create-customer-form"
          onSubmit={(data) => handleCreateCustomer(data)}
          schema={schema}
          options={{ defaultValues }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Grid item xs={12} sx={{ marginBottom: { md: 4 } }}>
                <GeneralForm />
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid item xs={12} sx={{ marginBottom: { xs: 4, md: 4 } }}>
                <ContactForm />
              </Grid>
              <Grid item xs={12}>
                <AddressForm />
              </Grid>
            </Grid>
          </Grid>
          <SubmitButtons />
        </Form>
      </PageContent>
    </div>
  )
}

export default CreateCustomerPage
